'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dProxies$002dPage$0024 from "./presto.-List-Proxies-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002483 from "./presto.-Presto-Router$$anon$83.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$82() {
  this.boV = null;
  this.boN = null;
  this.boO = false;
  this.boW = null;
  this.boX = false;
  this.bp0 = null;
  this.boT = null;
  this.boU = false;
  this.boP = null;
  this.boQ = false;
  this.boR = null;
  this.boS = false;
  this.boY = false;
  this.boZ = false;
  this.boV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bp0 = "ListProxiesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$82 as $c_Lpresto_PrestoRouter$$anon$82 };
$p = $c_Lpresto_PrestoRouter$$anon$82.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$82;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$82() {
}
export { $h_Lpresto_PrestoRouter$$anon$82 as $h_Lpresto_PrestoRouter$$anon$82 };
$h_Lpresto_PrestoRouter$$anon$82.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.boV;
});
$p.M = (function() {
  if ((!this.boO)) {
    this.boN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.boO = true;
  }
  return this.boN;
});
$p.O = (function() {
  if ((!this.boX)) {
    this.boW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.boX = true;
  }
  return this.boW;
});
$p.D = (function() {
  return this.bp0;
});
$p.t = (function() {
  if ((!this.boU)) {
    this.boT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boU = true;
  }
  return this.boT;
});
$p.N = (function() {
  if ((!this.boQ)) {
    this.boP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boQ = true;
  }
  return this.boP;
});
$p.Q = (function() {
  if ((!this.boS)) {
    this.boR = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002483.$c_Lpresto_PrestoRouter$$anon$83();
    this.boS = true;
  }
  return this.boR;
});
$p.v = (function() {
  if ((!this.boZ)) {
    this.boY = false;
    this.boZ = true;
  }
  return this.boY;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee542) => ((p) => \u03b4scrutinee542))($j_presto$002e$002dList$002dProxies$002dPage$0024.$m_Lpresto_ListProxiesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$82 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$82, "presto.PrestoRouter$$anon$82", ({
  OZ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$82 as $d_Lpresto_PrestoRouter$$anon$82 };
//# sourceMappingURL=presto.-Presto-Router$$anon$82.js.map
